import script from "./ExamSeatsManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamSeatsManagement.vue?vue&type=script&setup=true&lang=js"

import "./ExamSeatsManagement.vue?vue&type=style&index=0&id=5acb760a&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acb760a"]])

export default __exports__